/**
 * Relewise: Support markets
 * Filters products and variants by current market handle
 */

const POLL_INTERVAL_MS = 100;
const POLL_TIMEOUT_MS = 10_000;

/* eslint-disable @typescript-eslint/no-explicit-any */
export function applyRelewiseMarketFilter(marketHandle: string): boolean {
  if (
    typeof window.RelewiseWebComponents === 'undefined' ||
    typeof window.Relewise === 'undefined'
  ) {
    return false;
  }

  try {
    window.RelewiseWebComponents.addFilters({
      product: (builder: any) =>
        builder
          .addProductDataFilter(
            `${window.Shopify.shop}_MarketHandles`,
            (c: any) =>
              c.addContainsCondition(
                window.Relewise!.DataValueFactory.string(marketHandle)
              )
          )
          .addVariantDataFilter(
            `${window.Shopify.shop}_MarketHandles`,
            (c: any) =>
              c.addContainsCondition(
                window.Relewise!.DataValueFactory.string(marketHandle)
              )
          )
    });
    return true;
  } catch {
    return false;
  }
}

export function initRelewiseMarketFilter(marketHandle: string) {
  if (!applyRelewiseMarketFilter(marketHandle)) {
    const interval = setInterval(() => {
      if (applyRelewiseMarketFilter(marketHandle)) clearInterval(interval);
    }, POLL_INTERVAL_MS);
    setTimeout(() => clearInterval(interval), POLL_TIMEOUT_MS);
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */
